/// <amd-module name="Repos/Views/Settings/ProjectBranchPolicies/Components/ProjectBranchPoliciesList" />
import * as React from "react";
import { branchNameToRef } from "Repos/Common/Util/Ref";
import { ISettingsViewService } from "Repos/Views/Settings/Common/Services/SettingsViewService";
import * as Resources from "Repos/Views/Settings/ProjectBranchPolicies/Resources";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";
import { IListItemDetails, List, ListItem } from "VSSUI/List";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { IProjectPolicyItem } from "../Contracts";
import { transformScopeForDisplay } from "../ReadableScope";

export interface IProjectBranchPoliciesListProps {
    projectBranchPolicies: IProjectPolicyItem[];
    setSelectedRefs: (value: string) => void;
}

export class ProjectBranchPoliciesList extends VssComponent<IProjectBranchPoliciesListProps> {
    private settingsSvc: ISettingsViewService;

    public constructor(props: IProjectBranchPoliciesListProps, context: IVssComponentContext) {
        super(props, context);
        this.settingsSvc = context.pageContext.getService<ISettingsViewService>("SettingsViewService");
    }

    public render() {
        const { projectBranchPolicies } = this.props;

        const itemProvider = new ArrayItemProvider(projectBranchPolicies);

        return <List ariaLabel={Resources.ProjectBranchPoliciesCardTitle} itemProvider={itemProvider} renderRow={this.renderRow} width="100%" />;
    }

    private getScope = (item: IProjectPolicyItem) => {
        let refName = item.scope;

        if (refName.startsWith("*:")) {
            // should always be true
            refName = refName.substring(2);
        }

        return branchNameToRef(refName);
    };

    private onClick = (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.KeyboardEvent<HTMLAnchorElement> | undefined,
        item: IProjectPolicyItem
    ) => {
        if (!event || (!event.shiftKey && !event.ctrlKey)) {
            this.props.setSelectedRefs(this.getScope(item));

            if (event) {
                event.preventDefault();
            }
        }
    };

    private renderRow = (index: number, item: IProjectPolicyItem, details: IListItemDetails<IProjectPolicyItem>): JSX.Element => {
        return (
            <ListItem
                linkProps={{ href: this.settingsSvc.getUrl(undefined, this.getScope(item), undefined), onClick: event => this.onClick(event, item) }}
                key={index}
                index={index}
                details={details}
                className="settings-project-branch-policies-row"
            >
                <div className="flex-row h-scroll-hidden padding-horizontal-8 padding-vertical-4">
                    <Icon iconName="OpenSource" className="padding-horizontal-8 padding-vertical-4 font-size-ml" />
                    <span className="text-ellipsis flex-self-center">{transformScopeForDisplay(item.scope)}</span>
                </div>
            </ListItem>
        );
    };
}
